import ReactDOM from "react-dom";
import React from "react";
import {Provider} from "react-redux";
import {applyMiddleware, combineReducers, createStore} from "redux";
import thunk from "redux-thunk";
import reducers from "./redux/reducers";
import {SearchField, SearchLink} from "Components/SearchField";
import BasePage from "Pages/BasePage";
import {LanguageBox, LanguageLink} from "Components/LanguageBox/";
import {AppThemeContextProviderWrapper} from "Helpers/ThemeHelper";
import ReduxQuerySync from "redux-query-sync";
import {Footer} from "Components/Footer";
import {Header} from "Components/Header";
import * as actionTypes from "Consts/actionsTypes";
import {ServicePackageCard} from "Blocks/ServicePackages/components";

const reducer = combineReducers({
    ...reducers,
});
export const store = createStore(reducer, applyMiddleware(thunk));

export const RenderComponent = (model, element, menu) => {
    const App = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            {GetComponent(model, element)}
        </AppThemeContextProviderWrapper>
    );
    ReactDOM.render(
        <Provider store={store}>
            <App/>
        </Provider>,
        element
    );
};

let GetComponent = (model, element, searchQuery) => {
    return <BasePage model={model} element={element} searchQuery={searchQuery}/>;
};
export const RenderFooter = (footer, element, currentTheme) => {
    const FooterAnchor = () => (
        <AppThemeContextProviderWrapper currentTheme={currentTheme}>
            <Footer {...footer} element={element}/>
        </AppThemeContextProviderWrapper>
    );
    ReactDOM.render(<FooterAnchor/>, element);
};
export const RenderHeader = (header, element, currentTheme, divider) => {
    const HeaderAnchor = () => (
        <Provider store={store}>
            <AppThemeContextProviderWrapper currentTheme={currentTheme}>
                <Header {...header} element={divider}/>
            </AppThemeContextProviderWrapper>
        </Provider>
    );
    ReactDOM.render(<HeaderAnchor/>, element);
};

export const RenderSearchLink = (element, model) => {
    const SearchLinkAnchor = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            <SearchLink {...model} />
        </AppThemeContextProviderWrapper>
    );
    ReactDOM.render(
        <Provider store={store}>
            <SearchLinkAnchor/>
        </Provider>,
        element
    );
};

export const RenderSearchField = (element, model) => {
    const SearchFieldDiv = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            <SearchField {...model} />
        </AppThemeContextProviderWrapper>
    );
    ReactDOM.render(
        <Provider store={store}>
            <SearchFieldDiv/>
        </Provider>,
        element
    );
};

export const RenderLanguageLink = (element, LanguageLinkText, model) => {
    const LanguageLinkAnchor = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            <LanguageLink LinkText={LanguageLinkText}/>
        </AppThemeContextProviderWrapper>
    );
    ReactDOM.render(
        <Provider store={store}>
            <LanguageLinkAnchor/>
        </Provider>,
        element
    );
};

export const RenderLanguageField = (element, languages, model) => {
    const LanguageFieldDiv = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            <LanguageBox
                languages={languages}
                className={model?.ShowLanguageButtonAtBottom ? "only-desktop" : ""}
            />
        </AppThemeContextProviderWrapper>
    );

    ReactDOM.render(
        <Provider store={store}>
            <LanguageFieldDiv {...languages} />
        </Provider>,
        element
    );
};

export const RenderSearchPage = (element, model, searchQuery) => {
    const App = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            {GetComponent(model, element, searchQuery)}
        </AppThemeContextProviderWrapper>
    );

    ReactDOM.render(
        <Provider store={store}>
            <App/>
        </Provider>,
        element
    );

    ReduxQuerySync({
        store,
        params: {
            query: {
                selector: (state) => state.search.query,
                action: (value) => ({
                    type: "setQuery",
                    payload: value,
                }),
            },
        },
        initialTruth: "location",
        replaceState: true,
    });
};

export const RenderListPageWithCategory = (element, model, searchQuery) => {
    const App = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            {GetComponent(model, element, searchQuery)}
        </AppThemeContextProviderWrapper>
    );

    ReactDOM.render(
        <Provider store={store}>
            <App/>
        </Provider>,
        element
    );

    ReduxQuerySync({
        store,
        params: {
            categories: {
                selector: (state) => state.search.categories,
                action: (value) => ({
                    type: "setCategory",
                    payload: value,
                }),
            },
        },
        initialTruth: "location",
        replaceState: true,
    });
};

export const RenderListPageWithChildren = (element, model) => {
    const App = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            {GetComponent(model, element)}
        </AppThemeContextProviderWrapper>
    );

    ReactDOM.render(
        <Provider store={store}>
            <App/>
        </Provider>,
        element
    );

    ReduxQuerySync({
        store,
        params: {
            categories: {
                selector: (state) => state.listpage.categories,
                action: (value) => {
                    return {
                        type: actionTypes.LISTPAGE__SETCATEGORIES,
                        payload: value,
                    };
                },
            },
        },
        initialTruth: "location",
        replaceState: true,
    });
};

export const RenderServiceCard = (element, model) => {
    const ServicePackageCardAnchor = () => (
        <AppThemeContextProviderWrapper currentTheme={model.CurrentTheme}>
            <ServicePackageCard {...model} element={element}/>
        </AppThemeContextProviderWrapper>
    );
    ReactDOM.render(
        <Provider store={store}>
            <ServicePackageCardAnchor/>
        </Provider>, element);
}
